// 2025 Tennessee Titans final regular season stats.
// Source: ESPN — https://www.espn.com/nfl/team/stats/_/name/ten/tennessee-titans
// Snapshotted at the end of the 2025 regular season. Player headshots are
// served by ESPN's public CDN keyed on the canonical player id.

export const SEASON_LABEL = "2025 Stats";
export const SEASON_SOURCE_URL =
  "https://www.espn.com/nfl/team/stats/_/name/ten/tennessee-titans";

export const espnHeadshot = (id, size = 200) =>
  `https://a.espncdn.com/combiner/i?img=/i/headshots/nfl/players/full/${id}.png&h=${size}&w=${size}&scale=crop`;

// 5 marquee leader cards shown at the top of the section.
export const TEAM_LEADERS_2025 = [
  {
    key: "passing",
    label: "Passing Yards",
    value: "3,169",
    name: "Cam Ward",
    pos: "QB",
    espnId: "4688380",
    accent: "from-titans-blue/30 to-titans-blue/10",
  },
  {
    key: "rushing",
    label: "Rushing Yards",
    value: "1,082",
    name: "Tony Pollard",
    pos: "RB",
    espnId: "3916148",
    accent: "from-titans-red/30 to-titans-red/10",
  },
  {
    key: "receiving",
    label: "Receiving Yards",
    value: "560",
    name: "Chig Okonkwo",
    pos: "TE",
    espnId: "4360635",
    accent: "from-titans-blue/30 to-titans-blue/10",
  },
  {
    key: "tackles",
    label: "Tackles",
    value: "164",
    name: "Cedric Gray",
    pos: "LB",
    espnId: "4429834",
    accent: "from-titans-red/30 to-titans-red/10",
  },
  {
    key: "interceptions",
    label: "Interceptions",
    value: "3",
    name: "Cody Barton",
    pos: "LB",
    espnId: "3926229",
    accent: "from-titans-blue/30 to-titans-blue/10",
  },
];

// Passing (per-QB). row[0] = display name+pos, rest = GP/CMP/ATT/CMP%/YDS/AVG/YDS-G/LNG/TD/INT/SACK/SYL/RTG.
export const PASSING_2025 = {
  headers: ["GP", "CMP", "ATT", "CMP%", "YDS", "AVG", "YDS/G", "LNG", "TD", "INT", "SACK", "SYL", "RTG"],
  rows: [
    { name: "Cam Ward", pos: "QB", espnId: "4688380",
      stats: [17, 323, 540, 59.8, "3,169", 5.9, 186.4, 47, 15, 7, 55, 410, 80.2] },
    { name: "Brandon Allen", pos: "QB", espnId: "2574511",
      stats: [1, 17, 30, 56.7, 72, 2.4, 72.0, 21, 0, 1, 1, 7, 47.9] },
  ],
  totals: { label: "Team",
    stats: [17, 340, 570, 59.6, "3,241", 5.7, 190.6, 47, 15, 8, 56, 417, 78.4] },
};

// Rushing — GP CAR YDS AVG LNG BIG TD YDS/G FUM LST FD.
export const RUSHING_2025 = {
  headers: ["GP", "CAR", "YDS", "AVG", "LNG", "TD", "YDS/G", "FUM", "FD"],
  rows: [
    { name: "Tony Pollard",   pos: "RB", espnId: "3916148", stats: [17, 242, "1,082", 4.5, 65, 5, 63.6, 3, 48] },
    { name: "Tyjae Spears",   pos: "RB", espnId: "4428557", stats: [13, 72, 283, 3.9, 41, 2, 21.8, 0, 16] },
    { name: "Cam Ward",       pos: "QB", espnId: "4688380", stats: [17, 39, 159, 4.1, 20, 2, 9.4, 2, 15] },
    { name: "Julius Chestnut",pos: "RB", espnId: "4367567", stats: [17, 11, 40, 3.6, 27, 0, 2.4, 0, 4] },
    { name: "Chimere Dike",   pos: "WR", espnId: "4431268", stats: [17, 11, 18, 1.6, 9, 0, 1.1, 0, 0] },
  ],
  totals: { label: "Team", stats: [17, 378, "1,589", 4.2, 65, 9, 93.5, 10, 85] },
};

// Receiving — GP REC TGTS YDS AVG TD LNG YDS/G FUM YAC FD.
export const RECEIVING_2025 = {
  headers: ["GP", "REC", "TGTS", "YDS", "AVG", "TD", "LNG", "YDS/G", "YAC", "FD"],
  rows: [
    { name: "Chig Okonkwo",   pos: "TE", espnId: "4360635", stats: [17, 56, 79, 560, 10.0, 2, 43, 32.9, 342, 24] },
    { name: "Elic Ayomanor",  pos: "WR", espnId: "4883647", stats: [16, 41, 89, 515, 12.6, 4, 39, 32.2, 115, 30] },
    { name: "Chimere Dike",   pos: "WR", espnId: "4431268", stats: [17, 48, 74, 423, 8.8, 4, 38, 24.9, 220, 20] },
    { name: "Gunnar Helm",    pos: "TE", espnId: "4686728", stats: [16, 44, 55, 357, 8.1, 2, 34, 22.3, 159, 17] },
    { name: "Van Jefferson",  pos: "WR", espnId: "3930066", stats: [16, 29, 52, 350, 12.1, 1, 43, 21.9, 83, 17] },
    { name: "Calvin Ridley",  pos: "WR", espnId: "3925357", stats: [7, 17, 36, 303, 17.8, 0, 47, 43.3, 84, 13] },
    { name: "Tyjae Spears",   pos: "RB", espnId: "4428557", stats: [13, 45, 50, 264, 5.9, 0, 34, 20.3, 361, 10] },
    { name: "Tony Pollard",   pos: "RB", espnId: "3916148", stats: [17, 33, 41, 206, 6.2, 0, 29, 12.1, 203, 11] },
  ],
  totals: { label: "Team", stats: [17, 340, 530, "3,241", 9.5, 15, 47, 190.6, "1,627", 156] },
};

// Defense — GP SOLO AST TOT SACK TFL PD INT FF FR. (subset of ESPN's wider table)
export const DEFENSE_2025 = {
  headers: ["GP", "SOLO", "AST", "TOT", "SACK", "TFL", "PD", "INT", "FF", "FR"],
  rows: [
    { name: "Cedric Gray",        pos: "LB", espnId: "4429834", stats: [16, 97, 67, 164, 1, 7, 4, 0, 0, 1] },
    { name: "Amani Hooker",       pos: "S",  espnId: "4036134", stats: [16, 58, 23, 81, 1, 3, 8, 0, 0, 0] },
    { name: "Cody Barton",        pos: "LB", espnId: "3926229", stats: [17, 37, 44, 81, 1, 4, 11, 3, 0, 0] },
    { name: "Jeffery Simmons",    pos: "DT", espnId: "4035369", stats: [15, 39, 28, 67, 11, 17, 3, 0, 3, 0] },
    { name: "Darrell Baker Jr.",  pos: "CB", espnId: "4036660", stats: [17, 39, 16, 55, 0, 0, 7, 0, 0, 0] },
    { name: "Sebastian Joseph-Day",pos:"DT", espnId: "3047495", stats: [17, 22, 19, 41, 2, 6, 0, 0, 0, 1] },
    { name: "Xavier Woods",       pos: "S",  espnId: "3040572", stats: [11, 23, 16, 39, 1, 0, 3, 2, 0, 0] },
    { name: "T'Vondre Sweat",     pos: "DT", espnId: "4428617", stats: [12, 16, 18, 34, 2, 4, 1, 0, 0, 0] },
  ],
  totals: { label: "Team", stats: [17, 716, 490, "1,206", 42, 83, 63, 6, 7, 8] },
};

// Scoring — top contributors.
export const SCORING_2025 = {
  headers: ["GP", "RUSH", "REC", "TD", "FG", "PAT", "PTS"],
  rows: [
    { name: "Joey Slye",      pos: "PK", espnId: "3124084", stats: [16, 0, 0, 0, 28, 26, 110] },
    { name: "Tony Pollard",   pos: "RB", espnId: "3916148", stats: [17, 5, 0, 5, 0, 0, 30] },
    { name: "Chimere Dike",   pos: "WR", espnId: "4431268", stats: [17, 0, 4, 4, 0, 0, 24] },
    { name: "Elic Ayomanor",  pos: "WR", espnId: "4883647", stats: [16, 0, 4, 4, 0, 0, 24] },
    { name: "Cam Ward",       pos: "QB", espnId: "4688380", stats: [17, 2, 0, 2, 0, 0, 12] },
    { name: "Tyjae Spears",   pos: "RB", espnId: "4428557", stats: [13, 2, 0, 2, 0, 0, 12] },
    { name: "Gunnar Helm",    pos: "TE", espnId: "4686728", stats: [16, 0, 2, 2, 0, 0, 12] },
    { name: "Chig Okonkwo",   pos: "TE", espnId: "4360635", stats: [17, 0, 2, 2, 0, 0, 12] },
  ],
  totals: { label: "Team", stats: [17, 9, 15, 27, 29, 27, 284] },
};
